<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiPartyPopper } from "@mdi/js"

export default {
  name: "HolidayIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiPartyPopper,
    }
  }
}
</script>
